var log = require('util/logger').create('Conversation Error Handler');

module.exports = {
    handlerException : function(cid, e, r1, r2) {
        log.error("Application handler threw an exception when called with a response" +
                  "[cid=" + cid + " " +
                  "response=" + r1 + ", " + r2 + "] ",
                  e);
    },
    unknownConversation : function(cid, r1, r2) {
        log.debug("A response was received from a peer for a finished conversation and ignored" +
                  "[cid=" + cid + " " +
                  "response=" + r1 + ", " + r2 + "]");
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/conversation/logging-error-handler.js
// module id = 982
// module chunks = 1